import { useContext } from 'react';
import useFetchDealers from '@honda-canada/react-subapp-dealer-locator/lib/hooks/useFetchDealers';
import { productLineLetter } from '@honda-canada/react-subapp-dealer-locator/lib/utils/constants';
import { UserLocationContext } from '@honda-canada/user-location';
import { useAppName, useSettings } from '../../../../utils/sitecoreContext';
export const getSelectedPlace = (userLocation, defaultProvince, isProvince) => {
    if (userLocation.coordinates && !isProvince) {
        return {
            coordinates: userLocation.coordinates,
            isProvince,
            province: {
                abbreviation: userLocation.provinceCode || '',
            },
            city: {
                name: userLocation.city,
            },
        };
    }
    return {
        coordinates: {
            longitude: 0,
            latitude: 0,
        },
        isProvince,
        province: {
            abbreviation: userLocation.provinceCode || defaultProvince,
        },
    };
};
/**
 * Search dealers by coordinates or province
 * using data fetching hook from  dealer locator sub-app
 */
const useFetchDealerInventory = (isProvince) => {
    const appName = useAppName();
    const { defaultProvince } = useSettings();
    const userLocation = useContext(UserLocationContext);
    const productLineCode = productLineLetter.get(appName);
    const selectedPlace = getSelectedPlace(userLocation, defaultProvince, isProvince);
    const { data, error, isLoading: isFetching, } = useFetchDealers(selectedPlace, productLineCode);
    // FIXME: useFetchDealers is returning error message in `data` when 400
    const hasError = !!error || !data || !Array.isArray(data);
    return { hasError, isFetching, data: hasError ? undefined : data };
};
export default useFetchDealerInventory;
